
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venues",
      function () {
        return require("private-next-pages/venues/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venues"])
      });
    }
  